import { Button, Stack, Typography } from '@mui/material';
import { format } from 'date-fns';
import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import { contractDateFilterPivotMap } from '../../constants/contracts';
import DatePicker from '../forms/DatePicker';

type DateRangeForm = {
  startDate: Date | null;
  endDate: Date | null;
};

interface DateRangeFilterProps {
  closeFilterMenu: () => void;
  modifyFilters: (string, object) => void;
  startOrEnd: string;
}

function DateRangeFilter({ closeFilterMenu, modifyFilters, startOrEnd }: DateRangeFilterProps) {
  const form = useForm<DateRangeForm>({
    defaultValues: {
      startDate: null,
      endDate: null,
    },
  });

  const {
    handleSubmit,
    formState: {
      isValid,
    },
    watch,
  } = form;

  const onSubmit = ({ startDate, endDate }): void => {
    modifyFilters(contractDateFilterPivotMap[startOrEnd].filterName, {
      start: format(startDate, 'MM/dd/yyyy'),
      end: format(endDate, 'MM/dd/yyyy'),
    });

    closeFilterMenu();
  };

  const [startDate, endDate] = watch(['startDate', 'endDate']);

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <FormProvider {...form}>
      <Stack direction="column" spacing={1}>
          <DatePicker
            label="From date"
            name="startDate"
            rules={{
              required: { value: true, message: 'Start date is required.' },
            }}
            maxDate={endDate}
          />
        <Typography variant="body2">AND</Typography>
          <DatePicker
            label="To date"
            name="endDate"
            rules={{
              required: { value: true, message: 'End date is required.' },
            }}
            minDate={startDate}
          />
        <Button
          variant="contained"
          color="primary"
          disabled={!isValid}
          onClick={handleSubmit(onSubmit)}
          style={{ marginTop: '1rem' }}
        >
          Apply
        </Button>
      </Stack>
    </FormProvider>
  );
}

export default DateRangeFilter;
